import {Component, Input, OnInit, AfterViewInit, Output, OnDestroy} from '@angular/core';
import {ServiceService} from "../../services/service.service";



import {PagerDataObject} from "../../entities/pagerDataObject";

import {Service} from "../../entities/service";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/entities/user';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

 
  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  @Input()
  headers = [' ', 'Username', 'Name', 'Surname', 'Status', 'Roles'];
  @Input()
  disableHeader = false;
  subscription: any;
  private dataSub$ = new Subject<any>();
  query: String;
  errorResp: any;

  ngOnInit(): void {
    this.subscription = this.dataSub$.pipe(switchMap(filter => {
      return this.userService.getData(filter);
    }))
      .subscribe(data => {
        this.data = data;
      },error=>{
      this.errorResp = error.error
      });
    this.metaInfo = this.userService.getMetaInfo();
    this.columns = this.userService.getColumns();
  }

  ngAfterViewInit(): void {
    this.sharedService.loadMenuItems('admin');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

  }

  constructor(private userService: UserService, private sharedService: SharedService) {
  
  }

  onGridQuery(query) {
    this.query = query
    this.dataSub$.next(query);
  }

  deleteUser(entity){
    let user = new User();
    user.id = entity;
    this.userService.delete(user)
      .subscribe(service => {
        this.dataSub$.next(this.query);
      });
  }

}
